import React, { useState, useContext } from 'react';
import { SimpleDialog, Typography, styled } from '@nextiva/next-ui-components';
import {
  LicensesContext,
  actionTypes,
} from '../../../containers/pages/BillingLicenses/licensesContext/index';

const StyledDialogText = styled(Typography)`
  width: 349px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;
const StyledSupportLink = styled('a')`
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;

export const MultipleBillingLocationsModal = () => {
  const [modalOpen, setModalOpen] = useState(true);

  const { dispatch } = useContext(LicensesContext);

  const onOkButtonClick = (): void => {
    setModalOpen(false);
    dispatch({
      type: actionTypes.TOGGLE_PURCHASE_LICENSE_MODAL,
    });
  };

  return (
    <SimpleDialog
      data-testid="PlatformAdminUI-PurchaseLicenseModal-MultipleBillingLocationsModal"
      confirmButtonProps={{
        color: 'primary',
        onClick: onOkButtonClick,
        'data-testid':
          'PlatformAdminUI-PurchaseLicenseModal-MultipleBillingLocationsModalOkButton',
      }}
      confirmText="OK"
      title="Multiple billing locations"
      open={modalOpen}
    >
      <StyledDialogText variant="body2">
        Due to multiple billing locations, please contact your account manager
        or{' '}
        <StyledSupportLink
          href="https://www.nextiva.com/support/"
          target="_blank"
          rel="noreferrer"
          data-testid="PlatformAdminUI-PurchaseLicenseModal-MultipleBillingLocationsModalSupportLink"
        >
          chat with us
        </StyledSupportLink>{' '}
        to purchase licenses.
      </StyledDialogText>
    </SimpleDialog>
  );
};
